export const iconFontAwesomeMapsTrain = (
	<i className="fa-solid fa-train"></i>
);
